import ClearIcon from '@mui/icons-material/Clear'
import SearchIcon from '@mui/icons-material/Search'
import { Grid, InputAdornment, TextField } from '@mui/material'
import Button from '@mui/material/Button'
import { Dayjs } from 'dayjs'
import ExportExcel from '../../../components/Export'

export interface IFilterMapped {
  page?: number
  perPage?: number
  search?: string
  startDate?: string
  endDate?: string
}

interface FilterGroupProps {
  filter: IFilterMapped
  onFilterChange: (filter: IFilterMapped) => void
  onSearch: (filter: IFilterMapped) => void
  onDownload?: (date: Dayjs) => void
}

const TrackingPrintedHistoryFilter = (props: FilterGroupProps) => {
  const { filter, onFilterChange, onSearch, onDownload } = props
  const { page, perPage, search, startDate, endDate } = filter

  return (
    <Grid container spacing={2} mb={2}>
      <Grid item xs={12} lg={6}>
        <TextField
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          label={'หมายเลขพัสดุ'}
          fullWidth
          id="search"
          name="search"
          variant="filled"
          value={search ?? ''}
          onChange={(e) =>
            onFilterChange({ ...filter, search: e.target.value })
          }
        />
      </Grid>
      <Grid item xs={12} lg={2}>
        <Button
          color="primary"
          size="large"
          fullWidth
          variant="contained"
          startIcon={<SearchIcon />}
          onClick={() => onSearch(filter)}
          sx={{ height: '100%' }}
        >
          ค้นหา
        </Button>
      </Grid>
      <Grid item xs={4} lg={2}>
        <Button
          color="inherit"
          size="large"
          fullWidth
          variant="contained"
          startIcon={<ClearIcon />}
          onClick={() => {
            onFilterChange({
              page,
              perPage,
              search: undefined,
              startDate: undefined,
              endDate: undefined,
            })
            onSearch({
              page,
              perPage,
              search: undefined,
              startDate: undefined,
              endDate: undefined,
            })
          }}
          sx={{ height: '100%' }}
        >
          รีเซ็ต
        </Button>
      </Grid>
      {/* <Grid item xs={12} lg={2}>
        <ExportExcel filterDate={false} onDownload={onDownload} />
      </Grid> */}
    </Grid>
  )
}

export default TrackingPrintedHistoryFilter
